export default __webpack_public_path__ + "static/Jay.Geiger_flags_social-dc9192ed4041613cda06203b095b208a.jpg";